//
// Module for the Account Transactions Index view
//
rs.module("content/participant/member/accounttransactions/index",

    ["controls/data/grid"],

    function (gridModule) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, columnIds, rollupsGrid, transactionsGridLrsApi, ajaxUrl) {

            var filter = $.js(jsSelectors.filter);
            var includeCancelledCheckbox = filter.js(jsSelectors.includeCancelledCheckbox);

            var accountKey = $.js(jsSelectors.accountKey, { required: false });

            if (rollupsGrid) {

                rollupsGrid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {

                        gridModule.update(
                            ajaxUrl,
                            {
                                accountKey: accountKey.val(),
                                planKey: rows[0][columnIds.planKey],
                                employerKey: rows[0][columnIds.employerKey],
                                beginDate: new Date(rows[0][columnIds.beginDate]).toISODateString(),
                                endDate: new Date(rows[0][columnIds.endDate]).toISODateString(),
                                includeCancelled: includeCancelledCheckbox.is(':checked')
                            },
                            transactionsGridLrsApi.agGridApi,
                            function done() { }
                        );
                    }

                    _executeSelectionChanged = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);